var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopMenu = function SvgTopMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 16,
    viewBox: "0 0 4 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.315 6.5A1.75 1.75 0 1 1 .5 8.25 1.783 1.783 0 0 1 2.315 6.5zm0 6a1.75 1.75 0 1 1-1.814 1.75 1.783 1.783 0 0 1 1.815-1.75zM.502 2.207A1.75 1.75 0 0 1 4 2.25 1.787 1.787 0 0 1 2.185 4 1.75 1.75 0 0 1 .5 2.207z"
  })));
};
export default SvgTopMenu;